import $ from 'jquery';

function getParams(url) {
    const paramsString = window.location.href.split('?')[1]
    const paramsSplit = typeof paramsString !== 'undefined' ? paramsString.split('&') : null
    let params = [];

    if (paramsSplit !== null) {
        for (let param of paramsSplit) {
            const paramSplit = param.split('=');
            params.push({
                name: paramSplit[0],
                value: paramSplit[1] || '',
            });
        }
    }

    return params
}

export default function categorySelectDirective(context=document.body) {
    const siteUrl = $('.header_logo > a').attr('href');
    const $context = $(context);

    $context.find('[sw-category-select]').each(function() {
        const $this = $(this);

        $this.on('change', function(e) {
            let newUri = $this.find('select').val();
            const params = getParams(window.location.href);

            for (let param of params) {
                if (param.name === 'sort') {
                    newUri += `?sort=${param.value}`;
                }
            }

            window.location.href = siteUrl + newUri;
        });
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/commerce/category-select.js